import { render, staticRenderFns } from "./KnAuthorizationGradeDetail.vue?vue&type=template&id=8387d686&scoped=true"
import script from "./KnAuthorizationGradeDetail.js?vue&type=script&lang=js&external"
export * from "./KnAuthorizationGradeDetail.js?vue&type=script&lang=js&external"
import style0 from "./KnAuthorizationGradeDetail.vue?vue&type=style&index=0&id=8387d686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8387d686",
  null
  
)

export default component.exports